<template>
  <div class="page-container">
    <div class="yn-biz-header">
      <span class="yn-biz-title">表单查看</span>
      <div class="header-actions">
        <el-select
          v-model="curRwid"
          size="mini"
          placeholder="选择检测任务"
          filterable
          clearable
          style="width:420px"
          @change="onTaskChange"
        >
        <el-option
          v-for="t in tasks"
          :key="t.id"
          :label="taskLabel(t)"
          :value="String(t.id)"
        >
          <span>{{ t.rwbh || '—' }}</span>
          <span style="color:#8492a6;font-size:12px;margin-left:8px">{{ t.xmmc }}（{{ t.xmbh }}）</span>
        </el-option>
      </el-select>
        <el-button type="primary" size="mini" :disabled="!curRwid" @click="loadForms">刷新</el-button>
      </div>
    </div>

    <el-card v-if="taskInfo.rwid" shadow="never" style="margin-top:16px">
      <div slot="header" class="task-head">
        <span>任务信息</span>
        <el-tag v-if="projectPhase" size="small" type="primary">{{ projectPhase.xmzt_label }}</el-tag>
        <el-button v-if="taskInfo.xmbh" type="text" size="small" @click="$router.push({ path: '/task-track', query: { xmbh: taskInfo.xmbh } })">任务监控</el-button>
      </div>
      <el-descriptions :column="3" size="small" border>
        <el-descriptions-item label="任务编号">{{ taskInfo.rwbh || '—' }}</el-descriptions-item>
        <el-descriptions-item label="项目编号">{{ taskInfo.xmbh || '—' }}</el-descriptions-item>
        <el-descriptions-item label="项目名称">{{ taskInfo.xmmc || '—' }}</el-descriptions-item>
        <el-descriptions-item label="检测人员">{{ taskInfo.jcr_xm || '—' }}</el-descriptions-item>
      </el-descriptions>
    </el-card>

    <el-card v-if="taskInfo.xmbh" shadow="never" style="margin-top:16px">
      <div slot="header" class="task-head">
        <span>054 现场签字（采样 / 校核 / 审核）</span>
      </div>
      <el-alert
        type="info"
        :closable="false"
        show-icon
        title="签字请在 UniApp 完成"
        description="Web 端仅展示签字结果，现场手写签字请使用移动端 App。"
        style="margin-bottom:12px"
      />
      <div class="sign-row">
        <SignUserPicker
          v-for="role in signRoles054"
          :key="role"
          :role-label="role"
          :value="readSign(form054Sign, role)"
          mode="view"
        />
      </div>
    </el-card>

    <el-card v-if="taskInfo.xmbh" shadow="never" style="margin-top:16px">
      <div slot="header" class="task-head">
        <span>056 交接签字（交样 / 接样）</span>
      </div>
      <el-alert
        type="info"
        :closable="false"
        show-icon
        title="056 签字请在 UniApp 完成"
        description="交样人、接样人手写签字请使用移动端 App；下方表单列表中点「查看」可预览 056 交接单。"
        style="margin-bottom:12px"
      />
      <div class="sign-row">
        <SignUserPicker
          role-label="交样人"
          :value="readSign(form056Sign, '交样人')"
          mode="view"
        />
        <SignUserPicker
          role-label="接样人"
          :value="readSign(form056Sign, '样品管理员/接样人')"
          mode="view"
        />
      </div>
    </el-card>

    <div v-if="curRwid" v-loading="loading" style="margin-top:16px">
      <el-card v-for="grp in formGroups" :key="grp.cat" shadow="never" style="margin-bottom:12px">
        <div slot="header" class="cat-head">
          <span>{{ grp.cat }}</span>
          <el-tag size="mini" type="info">{{ grp.items.length }} 张</el-tag>
        </div>
        <el-table :data="grp.items" stripe border size="small">
          <el-table-column prop="bh" label="表单编号" width="180"></el-table-column>
          <el-table-column prop="mc" label="表单名称" min-width="200"></el-table-column>
          <el-table-column prop="scope" label="数据范围" width="140"></el-table-column>
          <el-table-column label="状态" width="100">
            <template slot-scope="{ row }">
              <el-tag :type="row.ready ? (row.hasData ? 'success' : 'warning') : 'info'" size="small">
                {{ row.ready ? (row.hasData ? '有数据' : '待录入') : '未启用' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="说明" min-width="140">
            <template slot-scope="{ row }">
              <span style="color:#909399;font-size:12px">{{ row.hint || '—' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="140" fixed="right">
            <template slot-scope="{ row }">
              <el-button type="text" size="small" :disabled="!row.ready" @click="viewForm(row)">查看</el-button>
              <el-button v-if="canEditForm(row)" type="text" size="small" :disabled="!row.ready" @click="editForm(row)">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </div>

    <el-empty v-else description="请先选择检测任务" style="margin-top:80px"></el-empty>

    <el-dialog
      :title="'查看表单 - ' + (viewTitle || '')"
      :visible.sync="showView"
      fullscreen
      top="0"
      custom-class="fill-dialog"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      @closed="onViewClosed"
    >
      <div v-if="templateLoading" class="view-placeholder">正在加载表单预览...</div>
      <OnlyOfficeViewer v-else-if="ooConfig" :config="ooConfig" />
      <div v-else class="view-placeholder">预览加载失败</div>
      <div slot="footer" class="view-dialog-footer">
        <el-button size="small" :disabled="!canViewPrev" @click="viewPrevForm">上一个表</el-button>
        <el-button size="small" :disabled="!canViewNext" @click="viewNextForm">下一个表</el-button>
        <el-button @click="showView=false">关闭</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="'编辑表单 - ' + (editTitle || '')"
      :visible.sync="showEdit"
      width="90%"
      top="3vh"
      :close-on-click-modal="false"
      @closed="editData = null"
    >
      <LabFormSheet v-if="editData && editNum" :form-num="editNum" :model="editData" scope="batch" :xmbh="taskInfo.xmbh || ''" />
      <div slot="footer">
        <el-button @click="showEdit=false">取消</el-button>
        <el-button type="primary" :loading="editSaving" @click="saveEditForm">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/utils/api'
import OnlyOfficeViewer from '@/components/OnlyOfficeViewer.vue'
import LabFormSheet from '@/components/LabFormSheet.vue'
import SignUserPicker from '@/components/SignUserPicker.vue'
import { getCurrentUser, isAdmin, readSignValue } from '@/utils/user'

const CAT_ORDER = ['派遣', '现场', '交接', '实验室']
const SIGN_ROLES_054 = ['采样', '校核', '审核']
const SIGN_ROLES_056 = ['交样人', '样品管理员/接样人']

export default {
  components: { OnlyOfficeViewer, LabFormSheet, SignUserPicker },
  data() {
    return {
      tasks: [],
      curRwid: '',
      taskInfo: {},
      forms: [],
      projectPhase: null,
      form054Sign: {},
      form056Sign: {},
      signRoles054: SIGN_ROLES_054,
      signRoles056: SIGN_ROLES_056,
      loading: false,
      showView: false,
      viewTitle: '',
      viewRow: null,
      viewRowIdx: -1,
      ooConfig: null,
      templateLoading: false,
      editableNums: ['054'],
      showEdit: false,
      editNum: '',
      editTitle: '',
      editData: null,
      editSaving: false
    }
  },
  computed: {
    formGroups() {
      const map = {}
      ;(this.forms || []).forEach(f => {
        const cat = f.cat || '其他'
        if (!map[cat]) map[cat] = []
        map[cat].push(f)
      })
      return CAT_ORDER.filter(c => map[c]).concat(Object.keys(map).filter(c => !CAT_ORDER.includes(c))).map(cat => ({
        cat,
        items: map[cat]
      }))
    },
    viewableForms() {
      return (this.forms || []).filter(f => f.ready)
    },
    canViewPrev() {
      return this.viewRowIdx > 0
    },
    canViewNext() {
      return this.viewRowIdx >= 0 && this.viewRowIdx < this.viewableForms.length - 1
    }
  },
  mounted() {
    this.bootstrap()
  },
  methods: {
    readSign(data, role) {
      return readSignValue(data || {}, role)
    },
    canEditForm(row) {
      const num = String(row.num)
      if (num === '054') return true
      if (num === '093' && this.projectPhase && this.projectPhase.soil_physics) return true
      return false
    },
    taskLabel(t) {
      const rw = t.rwbh || '无任务号'
      return `${rw} · ${t.xmmc || t.xmbh || ''}`
    },
    onViewClosed() {
      this.ooConfig = null
      this.viewRow = null
      this.viewRowIdx = -1
    },
    async bootstrap() {
      await this.loadTasks()
      const q = this.$route.query || {}
      if (q.rwid) {
        this.curRwid = String(q.rwid)
      } else if (q.xmbh) {
        const hit = this.tasks.find(t => t.xmbh === q.xmbh)
        if (hit) this.curRwid = String(hit.id)
      }
      if (this.curRwid) await this.loadForms()
      const formNum = q.form ? String(q.form).replace(/\D/g, '') : ''
      if (formNum && q.xmbh && !this.curRwid) {
        this.$router.replace({
          path: '/forms/docx',
          query: { xmbh: q.xmbh, form_num: formNum, scope: 'batch' }
        }).catch(() => {})
        return
      }
      if (formNum && this.taskInfo.xmbh) {
        const row = (this.forms || []).find(f => String(f.num) === formNum)
        if (row && row.ready) {
          if (this.canEditForm(row)) {
            this.editForm(row)
          } else {
            this.viewForm(row)
          }
        }
      }
    },
    async loadTasks() {
      const u = getCurrentUser()
      if (!u.id) {
        this.$message.warning('登录已失效，请重新登录')
        this.$router.push('/login')
        return
      }
      try {
        let res = await api.get('yn_tr_form_tasks', { yhid: u.id })
        let data = res.data
        if (data && data.error) {
          this.$message.warning(data.error)
          this.tasks = []
          return
        }
        let list = Array.isArray(data) ? data : (data && data.tasks ? data.tasks : [])
        if (list.length === 0 && isAdmin(u)) {
          const res2 = await api.get('yn_rwfp_list')
          list = Array.isArray(res2.data) ? res2.data.map(r => ({
            id: r.id,
            rwbh: r.rwbh,
            xmbh: r.xmbh,
            xmmc: r.xmmc,
            jcr_xm: r.jcr_xm,
            rwzt: r.rwzt,
            wcrq: r.wcrq,
            sample_count: r.sample_count
          })) : []
        }
        this.tasks = list
        if (list.length === 0) {
          this.$message.info('暂无检测任务，请先在「采样任务管理」安排采样人员')
        }
      } catch (e) {
        this.tasks = []
        this.$message.error('加载任务列表失败')
      }
    },
    onTaskChange() {
      if (this.curRwid) {
        this.loadForms()
      } else {
        this.taskInfo = {}
        this.forms = []
      }
    },
    async loadForms() {
      if (!this.curRwid) return
      const u = getCurrentUser()
      this.loading = true
      try {
        const res = await api.get('yn_tr_form_list', { rwid: this.curRwid, yhid: u.id || '' })
        const data = res.data || {}
        if (data.error) {
          this.$message.warning(data.error)
          this.forms = []
          return
        }
        this.taskInfo = {
          rwid: data.rwid,
          rwbh: data.rwbh,
          xmbh: data.xmbh,
          xmmc: data.xmmc,
          jcr_xm: data.jcr_xm
        }
        this.forms = data.forms || []
        if (data.xmbh) {
          this.loadProjectPhase(data.xmbh)
          await this.loadForm054Sign(data.xmbh)
          await this.loadForm056Sign(data.xmbh)
        }
      } catch (e) {
        this.$message.error('加载表单列表失败')
        this.forms = []
      } finally {
        this.loading = false
      }
    },
    async viewForm(row) {
      if (!row || !row.ready || !this.curRwid) return
      const list = this.viewableForms
      const idx = list.findIndex(f => String(f.num) === String(row.num))
      this.viewRowIdx = idx >= 0 ? idx : 0
      this.viewRow = list[this.viewRowIdx] || row
      await this.loadViewDocx(this.viewRow)
    },
    viewPrevForm() {
      if (!this.canViewPrev) return
      this.viewRowIdx -= 1
      this.viewRow = this.viewableForms[this.viewRowIdx]
      this.loadViewDocx(this.viewRow)
    },
    viewNextForm() {
      if (!this.canViewNext) return
      this.viewRowIdx += 1
      this.viewRow = this.viewableForms[this.viewRowIdx]
      this.loadViewDocx(this.viewRow)
    },
    async loadViewDocx(row) {
      if (!row || !this.curRwid) return
      this.viewTitle = row.mc
      this.templateLoading = true
      this.ooConfig = null
      this.showView = true
      try {
        const res = await api.get('yn_tr_form_docx', {
          rwid: this.curRwid,
          num: row.num,
          yhid: getCurrentUser().id || ''
        })
        const payload = res.data || {}
        if (payload.error) {
          this.$message.warning(payload.error)
          this.showView = false
          return
        }
        if (!payload.document || !payload.document.url) {
          this.$message.error('未获取到文档地址')
          this.showView = false
          return
        }
        this.ooConfig = payload
      } catch (e) {
        this.ooConfig = null
        this.$message.error('加载表单预览失败')
      } finally {
        this.templateLoading = false
      }
    },
    async loadProjectPhase(xmbh) {
      try {
        const res = await api.get('yn_tr_project_phase', { xmbh })
        this.projectPhase = res.data && !res.data.error ? res.data : null
      } catch (e) {
        this.projectPhase = null
      }
    },
    async loadForm054Sign(xmbh) {
      try {
        const res = await api.get('yn_tr_field_form', { xmbh, num: '054' })
        this.form054Sign = (res.data && res.data.data) ? { ...res.data.data } : {}
      } catch (e) {
        this.form054Sign = {}
      }
    },
    async loadForm056Sign(xmbh) {
      try {
        const res = await api.get('yn_tr_field_form', { xmbh, num: '056' })
        this.form056Sign = (res.data && res.data.data) ? { ...res.data.data } : {}
      } catch (e) {
        this.form056Sign = {}
      }
    },
    async editForm(row) {
      if (!row || !this.taskInfo.xmbh) return
      this.editNum = String(row.num)
      this.editTitle = row.mc
      this.showEdit = true
      try {
        const res = await api.get('yn_tr_field_form', { xmbh: this.taskInfo.xmbh, num: row.num })
        if (res.data && res.data.error) {
          this.$message.warning(res.data.error)
          this.showEdit = false
          return
        }
        this.editData = { ...(res.data.data || {}) }
      } catch (e) {
        this.$message.error('加载表单失败')
        this.showEdit = false
      }
    },
    async saveEditForm() {
      if (!this.taskInfo.xmbh || !this.editNum || !this.editData) return
      this.editSaving = true
      try {
        const res = await api.post('yn_tr_field_form', {
          xmbh: this.taskInfo.xmbh,
          num: this.editNum,
          data: JSON.stringify(this.editData)
        })
        if (res.data && res.data.error) {
          this.$message.error(res.data.error)
          return
        }
        this.$message.success('已保存')
        this.showEdit = false
        this.loadForms()
      } catch (e) {
        this.$message.error('保存失败')
      } finally {
        this.editSaving = false
      }
    }
  }
}
</script>

<style scoped>
.search-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
.cat-head {
  display: flex;
  align-items: center;
  gap: 8px;
}
.sign-row {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  padding: 8px 0;
}
.task-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.view-placeholder {
  text-align: center;
  padding: 40px;
  color: #909399;
}
.view-dialog-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}
.fill-dialog ::v-deep .el-dialog__body {
  padding: 0;
  background: #f5f5f5;
  overflow: hidden;
}
</style>
